import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, skip, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }
  private domain = environment.domain;

  private yearSub = new BehaviorSubject<{ year: number | string, strategyid: number }>({ year: 0, strategyid: 0 });
  getIndicatorResultsJsonReport$ = this.yearSub.asObservable().pipe(skip(1), switchMap(({ year, strategyid }) => {
    return this.getIndicatorResultsJsonReport(strategyid, year)
  }));
  setyearSub(year: number, strategyid: number) {
    this.yearSub.next({ year, strategyid })
  }



  //project
  downloadProjectsStatusReport(strategyId: number = 1, fileType: string, locale: string = 'ar') {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/projects?mode=download&fileType=${fileType}&locale=${locale}`, {
      responseType: 'blob'
    })
  };
  getProjectsStatusReport(strategyId: number = 1, departmentId: number | string, year: number | string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/projects?mode=view&departmentId=${departmentId}&year=${year}`, {

    })
  };


  //project budject
  downloadProjectsBudgetReport(strategyId: number, fileType: string, locale: string = 'ar') {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/projects-budget?mode=download&fileType=${fileType}&locale=${locale}`, {
      responseType: 'blob'
    })
  };
  getProjectsBudgetJsonReport(strategyId: number = 1, departmentId: number | string, year: number | string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/projects-budget?mode=view&departmentId=${departmentId}&year=${year}`)
  };

  //induicators
  downloadIndicatorResultsReport(strategyId: number = 1, year: number, fileType: string, locale: string = 'ar') {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/indicators?mode=download&fileType=${fileType}&year=${year}&locale=${locale}`, {
      responseType: 'blob'
    })
  };
  getIndicatorResultsJsonReport(strategyId: number = 1, year: number | string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/indicators?mode=view&year=${year}`)
  };

  // Employee reports
  getMyProjectsReport(strategyId: number, year: number | string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/my-projects?mode=view&year=${year}`)
  }

  downloadMyProjectsReport(strategyId: number, fileType: string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/my-projects?mode=download&fileType=${fileType}`, {
      responseType: 'blob'
    })
  }

  getMyIndicatorsReport(strategyId: number, year: number | string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/my-indicators?mode=view&year=${year}`)
  }

  downloadMyIndicatorsReport(strategyId: number, year: number | string, fileType: string) {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/my-indicators?mode=download&fileType=${fileType}&year=${year}`, {
      responseType: 'blob'
    })
  }

  downloadSingleProjectReport(strategyId: number, projectId: number, locale: string = 'ar') {
    return this.http.get(this.domain + `strategies/${strategyId}/reports/projects/${projectId}/download?locale=${locale}`, {
      responseType: 'blob'
    })
  }

} 
